import type { WidgetConfig } from '../../shared/interfaces';

const widgetConfigs = new Map<HTMLElement, WidgetConfig>();

export const getWidgetConfig = async (widget: HTMLElement): Promise<WidgetConfig> => {
    const existingConfig = widgetConfigs.get(widget);
    if (existingConfig) {
        return existingConfig;
    }

    const widgetSlugOrJson = widget.getAttribute(`widget`);
    if (!widgetSlugOrJson) {
        throw new Error(`You must add widget attribute to a custom element.`);
    }

    if (widgetSlugOrJson.startsWith(`{`)) {
        try {
            const config: WidgetConfig = JSON.parse(widgetSlugOrJson);
            widgetConfigs.set(widget, config);
            return config;
        } catch (err) {
            throw new Error(`Fix widget configuration, must be a valid JSON.`);
        }
    }

    const result = await fetch(`${window.mh.apiUrl}/v1/programs/${window.mh.programSlug}/widgets/${widgetSlugOrJson}/config`, {
        method: `GET`,
    });

    if (!result.ok) {
        console.error(result);
        throw new Error(`Could not obtain widget configuration.`);
    }

    const config = await result.json();
    widgetConfigs.set(widget, config);
    return config;
};
